module.exports = __webpack_public_path__ + "img/pooh-pooh_ios_802.png";